export default "__VITE_ASSET__CkYcLvuR__"